<template>
  <div class="flex-with-gap">
    <mf-tooltip bottom variant="secondary" max-width="324px" :disabled="disabled">
      <template #activator>
        <span class="cinza-0-14px"><strong>Preço 1: </strong>R$ {{ localeString(product.price_1, 2) }}</span>
      </template>
      <span>O preço 1 é utilizado apenas para a exibição da oferta no app. O preço 1 não é aplicado no PDV.</span>
    </mf-tooltip>

    <popover-edit ref="popoverMenu" :title="product.name" :disabled="disabled" @cancel="cancel" @submit="submit">
      <currency-input
        v-model="localPrice"
        label="Preço 1"
        :error="localPriceErrors.length > 0"
        :error-messages="localPriceErrors"
        @submit="submit"
        @input="$v.localPrice.$touch()"
        @blur="$v.localPrice.$touch()"
      ></currency-input>
    </popover-edit>
  </div>
</template>

<script>
import PopoverEdit from '../PopoverEdit.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Price1Edit',
  components: {
    PopoverEdit,
    CurrencyInput: () => import('./CurrencyInput.vue'),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    localPrice: 0,
  }),
  computed: {
    localPriceErrors() {
      const errors = []
      if (!this.$v.localPrice.$dirty) return errors
      !this.$v.localPrice.required && errors.push('Preenchimento obrigatório.')
      !this.$v.localPrice.higherThanZero && errors.push('O preço 1 precisa ser maior que zero.')
      !this.$v.localPrice.higherThanPrice2 && errors.push('O preço 1 precisa ser maior que o preço 2.')
      return errors
    },
  },
  mounted() {
    this.localPrice = parseFloat(this.product.price_1)
  },
  methods: {
    invalidInput() {
      this.$v.$touch()
      return this.$v.$invalid
    },
    submit() {
      if (this.invalidInput()) return
      this.product.price_1 = this.localPrice
      this.$refs.popoverMenu.close()
    },
    cancel() {
      this.localPrice = this.product.price_1
    },
  },
  validations: {
    localPrice: {
      required,
      higherThanZero(value) {
        return value > 0
      },
      higherThanPrice2(value) {
        return value > parseFloat(this.product.price_2)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-with-gap {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.cinza-0-14px {
  font-size: 14px;
  color: $cinza-0;
}
</style>
